import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';

import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HttpClientModule } from '@angular/common/http';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { NewLicenseComponent } from './new-license/new-license.component';
import { LicenseListComponent } from './license-list/license-list.component';
import { LoaderComponent } from './loader/loader.component';
import { AddDeviceComponent } from './add-device/add-device.component';
import { LinkDeviceDialogComponent } from './link-device-dialog/link-device-dialog.component';
import { DelinkDeviceDialogComponent } from './delink-device-dialog/delink-device-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DeviceSearchComponent } from './device-search/device-search.component';
import { DeviceService } from './device.service';
import { LicenseService } from './license.service';
import { AccountService } from './account.service';
import { SearchAccountComponent } from './search-account/search-account.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { KioskSetupWizardComponent } from './kiosk-setup-wizard/kiosk-setup-wizard.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { KioskOverviewComponent } from './kiosk-setup-wizard/kiosk-overview/kiosk-overview.component';
import { KioskEditComponent } from './kiosk-edit/kiosk-edit.component';
import { KioskService } from './kiosk.service';
import { KioskListComponent } from './kiosk-list/kiosk-list.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { KioskEditDialogComponent } from './kiosk-edit-dialog/kiosk-edit-dialog.component';
import { KioskEditTenantsComponent } from './kiosk-edit-tenants/kiosk-edit-tenants.component';
import { KioskEditTenantDialogComponent } from './kiosk-edit-tenant-dialog/kiosk-edit-tenant-dialog.component';
import { LinkDeviceToMemberDialogComponent } from './link-device-to-member-dialog/link-device-to-member-dialog.component';
import { AddAccountComponent } from './add-account/add-account.component';
import { KioskDiagnosticsDialogComponent } from './kiosk-diagnostics-dialog/kiosk-diagnostics-dialog.component';
import { KioskDecommissionDialogComponent } from './kiosk-decommission-dialog/kiosk-decommission-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { AuthService } from './auth.service';
import { LoginComponent } from './login/login.component';
import { DeviceListComponent } from './device-list/device-list.component';
import { HeadsetListComponent } from './headset-list/headset-list.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { HeadsetSearchComponent } from './headset-search/headset-search.component';

const appRoutes: Routes = [
  // { path: '', redirectTo: '/license/new', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'account_details', component: AccountDetailsComponent },
  { path: 'license_new', component: NewLicenseComponent },
  { path: 'account_new', component: AddAccountComponent },
  { path: 'licenses', component: LicenseListComponent },
  // { path: 'device_new', component: AddDeviceComponent },
  { path: 'device_search', component: DeviceSearchComponent },
  { path: 'account_search', component: SearchAccountComponent },
  { path: 'headset_search', component: HeadsetSearchComponent },
  // { path: 'setup', component: KioskSetupWizardComponent },
  // { path: 'kiosks', component: KioskListComponent },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  declarations: [
    AppComponent,
    NewLicenseComponent,
    LicenseListComponent,
    AddDeviceComponent,
    LinkDeviceDialogComponent,
    DelinkDeviceDialogComponent,
    DeviceSearchComponent,
    SearchAccountComponent,
    KioskSetupWizardComponent,
    KioskOverviewComponent,
    KioskListComponent,
    KioskEditTenantsComponent,
    LoaderComponent,
    KioskEditComponent,
    KioskEditDialogComponent,
    KioskEditTenantDialogComponent,
    LinkDeviceToMemberDialogComponent,
    AddAccountComponent,
    KioskDiagnosticsDialogComponent,
    KioskDecommissionDialogComponent,
    ConfirmDialogComponent,
    LoginComponent,
    DeviceListComponent,
    HeadsetListComponent,
    AccountDetailsComponent,
    HeadsetSearchComponent,
  ],
  imports: [
    MatAutocompleteModule,
    MatStepperModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatToolbarModule,
    MatCardModule,
    MatListModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    FormsModule,
    MatIconModule,
    MatMenuModule,
    MatTableModule,
    MatDatepickerModule,
    MatSnackBarModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    QRCodeModule,
    RouterModule.forRoot(
      appRoutes,
      // { enableTracing: true } // <-- debugging purposes only
    ),
  ],
  providers: [
    HttpClientModule,
    DeviceService,
    LicenseService,
    AccountService,
    KioskService,
    AuthService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    LinkDeviceDialogComponent,
    DelinkDeviceDialogComponent,
    KioskEditDialogComponent,
    KioskEditTenantDialogComponent,
    LinkDeviceToMemberDialogComponent,
    KioskDiagnosticsDialogComponent,
    KioskDecommissionDialogComponent,
    ConfirmDialogComponent,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts